<template>
  <div class="pregled-vsebine" v-if="allLoaded">
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <p class="open-sans-30pt">
          T2 Cloud
        </p>

        <div v-if="editProjectPage">
          <div
            style="padding:5px; margin:5px 0px 20px 0px; border-top: solid 1px lightgray;border-bottom: solid 1px lightgray;">
            <span class="breadcrumbClickable" @click="editProjectPage = false">T2 Cloud</span>
            <i class="el-icon-arrow-right" v-if="editProjectPage"></i>
            <span v-if="editProjectPage">Projekt {{ selectedProject.projectName }}</span>
          </div>
          <CloudProjectEdit :project="selectedProject"></CloudProjectEdit>
        </div>

        <div v-if="!editProjectPage">
          <p class="navadno-besedilo" style="padding-top: 30px">
            Na tej strani so izbrani vsi vaši cloud projekti.
            Lastniki in skrbniki projektov lahko dodajajo uporabnike, vsak uporabnik pa si lahko zamenja svoje geslo.
          </p>
          <CloudPermissionRequests
            v-on:requestChanged="permissionRequestChanged"
          ></CloudPermissionRequests>
          <el-row :type="rowType" :gutter="0" style="margin-top: 50px;">
            <el-col :span="24">
              <div style="display: flex;margin-bottom: 20px">
                <el-select v-model="selectedProject" placeholder="Izberite projekt" style="flex: auto; "
                           value-key="idTerminationPoint">
                  <el-option
                    v-for="project in projectListBLL.list"
                    :key="project.idTerminationPoint"
                    :label="project.name"
                    :value="project"
                  >
                    <span style="float: left">{{ project.name }}</span>
                    <span style="float: right; color: #8492a6; font-size: 13px">{{ project.siteName }}</span>
                  </el-option>
                </el-select>
<!--                <el-button icon="el-icon-s-tools" plain v-if="selectedProject!==null && selectedProject.owner"-->
<!--                           style="margin-left: 10px;" @click="getProjectDetails(); editProjectPage = true">-->
<!--                </el-button>-->
              </div>
            </el-col>
          </el-row>
          <el-row :type="rowType" :gutter="0" v-if="selectedProject!==null">
            <el-col
              :span="24"
              :lg="isSelectedProjectAndOwner ? 11 : 24"
              style="margin-bottom: 20px;"
            >
              <div style="font-size: 24px;margin-bottom: 15px;">
                Osnovni podatki
              </div>
              <div style="display:flex; border-bottom: 1px dashed lightgrey; padding: 5px 0px">
                <div>Ime projekta</div>
                <div style="flex:auto; text-align: right">{{selectedProject.name}}</div>
              </div>
              <template v-if="isSelectedProjectAndOwner && loggedInUser.username!==null">
                <div style="display:flex; border-bottom: 1px dashed lightgrey; padding: 5px 0px">
                  <div>ID projekta</div>
                  <div style="flex:auto; text-align: right">{{selectedProject.projectId}}</div>
                </div>
                <div style="display:flex; border-bottom: 1px dashed lightgrey; padding: 5px 0px">
                  <div>Status</div>
                  <div :style="`flex:auto; text-align: right;font-weight: bold; color: ${selectedProject.statusColor} `">{{selectedProject.statusName}}</div>
                </div>
                <div style="display:flex; border-bottom: 1px dashed lightgrey; padding: 5px 0px">
                  <div>Lokacija</div>
                  <div style="flex:auto; text-align: right">{{selectedProject.siteName}}</div>
                </div>
              </template>
              <div style="text-align: right;">
                <a :href="selectedProject.loginUrl" target="_blank" style="text-decoration: none;">
                  <el-button style="margin-top:10px;" type="primary" size="mini">
                    Prijava
                  </el-button>
                </a>
              </div>
            </el-col>
            <el-col :span="24" :lg="2" style="text-align: center;" v-if="isSelectedProjectAndOwner"
                    class="hidden-md-and-down">
              <div class="el-divider el-divider--vertical" style="height: 100%;"></div>
            </el-col>
            <el-col :span="24" :lg="11" style="margin-bottom: 20px;" v-if="isSelectedProjectAndOwner">
              <div style="font-size: 24px;margin-bottom: 10px;">
                Storitve projekta
              </div>
              <template v-for="group in selectedProject.serviceGroups">
                <div style="font-size: 16px; font-weight: bold; margin-bottom: 5px; margin-top: 5px;">{{group.name}}</div>
                <div v-for="service in group.services" style="display:flex; border-bottom: 1px dashed lightgrey; padding: 5px 0px">
                  <div style="flex:auto;">{{service.name}}</div>
                  <div>{{service.quantity}}</div>
                  <div style="width: 40px; text-align: right;">{{service.unitType}}</div>
                </div>
              </template>
            </el-col>
          </el-row>
          <el-row :type="rowType" :gutter="0" v-if="selectedProject!==null">
            <el-col :span="24" :lg="11" style="margin-bottom: 20px;">
              <div style="font-size: 24px;margin-bottom: 15px;">
                Uporabniki projekta
              </div>
              <template v-for="(user, userIndex) in selectedProject.users.list">
                <div
                  :class="'projectUsersListItem '+userClass(userIndex)"
                  style="display: flex; padding: 5px;">
                  <div style="margin: auto 10px auto 0px; ">
                    <i :class="user.ownUser ? 'el-icon-user-solid' : 'el-icon-user'"
                       :title="user.ownUser ? 'Lasten cloud uporabnik' : 'Povabljen cloud uporabnik'"
                    ></i>
                  </div>
                  <div style="flex: auto; display: flex; flex-direction: column">
                    <div style="font-weight: bold; font-size:14px;">{{ user.username }}</div>
                    <div style="font-size: 12px">T-2 ID: {{user.ownerEmail}}</div>
                  </div>
                  <div>
                    <el-button icon="el-icon-s-tools" plain size="mini" style="margin: 5px; font-size: 16px;"
                               @click="editUserClick(user)">
                    </el-button>
                  </div>
                </div>
              </template>
              <div style="text-align: right; margin-top:10px">
                <el-button type="primary" size="mini" v-if="canAddUser(selectedProject)"
                           style="margin: 5px 5px 0px 5px;" @click="userAddDialog = true">
                  Dodaj uporabnika
                </el-button>
              </div>
            </el-col>
            <el-col :span="24" :lg="2" style="text-align: center;" v-if="selectedProject!==null"
                    class="hidden-md-and-down">
              <div class="el-divider el-divider--vertical" style="height: 100%;"></div>
            </el-col>
            <el-col
              :span="24"
              :lg="11"
              style="margin-bottom: 20px;"
              v-if="selectedProject!==null && selectedProject.permissions!=null && loggedInUser.username!==null"
            >
              <div style="font-size: 24px;margin-bottom: 15px;">
                Pravice na projektu
              </div>
              <template v-for="permission in selectedProject.getProjectPermissions()">
                <div style="display: flex; padding: 5px; border-bottom: 1px dashed lightgray">
                  <div style="margin: auto 10px auto 0px; flex: auto;">
                    <div
                      :style="`font-size:14px; ${(permission.requestId !== null) ? '' : 'color: green; font-weight: bold'}`"
                    >{{ permission.permissionName }}
                    </div>
                    <div style="font-weight: bold;">{{ permission.permissionReceiverEmail }}</div>
                  </div>

                  <div style="text-align: right">
                    <el-tooltip placement="left">
                      <div slot="content">
                        <div>Datum:
                          <b>{{ permission.date }}</b>
                        </div>
                        <div>Dodelil:
                          <b>{{ permission.permissionGiverEmail }}</b>
                        </div>
                        <div>Status:
                          <b v-if="permission.requestId !== null" style="color:blue;">čaka potrditev</b>
                          <b v-else style="color:green;">aktiven</b>
                        </div>
                      </div>
                      <el-button icon="el-icon-info" plain size="mini" style="margin: 5px; font-size: 16px;">
                      </el-button>
                    </el-tooltip>
                    <el-button
                      icon="el-icon-success"
                      plain size="mini"
                      style="margin: 5px; font-size: 16px;"
                      title="Sprejmi pravico"
                      v-if="
                          permission.requestId !== null &&
                          permission.permissionReceiverEmail === loggedInUser.email
                        "
                      @click="acceptPermissionRequest(permission)"
                    >
                    </el-button>
                    <el-button
                      icon="el-icon-error"
                      plain size="mini"
                      style="margin: 5px; font-size: 16px;"
                      title="Zavrni pravico"
                      v-if="
                          permission.requestId !== null &&
                          permission.permissionReceiverEmail === loggedInUser.email
                        "
                      @click="declinePermissionRequest(permission)"
                    >
                    </el-button>
                    <el-button
                      icon="el-icon-error"
                      plain size="mini"
                      style="margin: 5px; font-size: 16px;"
                      title="Prekliči dodelitev pravice"
                      v-if="
                          permission.requestId !== null &&
                          (permission.permissionGiver === loggedInUser.username || selectedProject.owner)
                        "
                      @click="cancelPermissionRequest(permission)"
                    >
                    </el-button>
                    <el-button
                      icon="el-icon-delete-solid"
                      plain size="mini"
                      title="Odstrani pravico"
                      style="margin: 5px; font-size: 16px;"
                      v-if="permission.requestId === null"
                      @click="removePermission(permission)"
                    >
                    </el-button>
                  </div>
                </div>
              </template>
              <div style="text-align: right; margin-top:10px">
                <el-button type="primary" size="mini" v-if="canInviteOthers(selectedProject)"
                           style="margin: 5px 5px 0px 5px;" @click="userInviteDialog = true">
                  Povabi
                </el-button>
              </div>
            </el-col>
          </el-row>
          <div class="redBox" v-if="selectedProject !== null && selectedProject.owner">
            <div style="font-weight: bold;">Izbriši projekt</div>
            <div style="margin: 10px 0px 10px 0px">Če se odločite za to možnost, bo projekt izbrisan. Storitve, povezane s projektom, se ne bodo več zaračunavale.</div>
            <div style="text-align: right;">
              <el-button type="danger" size="mini" @click="deleteProjectDialog = true; deleteProjectForm.deleteProjectConfirmInput = ''">
                Da, odstrani projekt
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      append-to-body
      :title="`Urejanje uporabnika `+ ((userEdit!==null)?userEdit.username:'')"
      :visible.sync="userEditDialog"
      :width="userEditDialogWidth"
      :fullscreen="$screen.breakpoint === 'xs'"
      v-if="userEditDialog"
    >
      <CloudUserEdit
        :user="userEdit"
        :project="selectedProject"
        v-on:userRemovedFromProject="userEditDialog = false"
      ></CloudUserEdit>
    </el-dialog>

    <el-dialog
      append-to-body
      :title="`Povabi nove osebe k delu na projektu`"
      :visible.sync="userInviteDialog"
      :width="userEditDialogWidth"
      :fullscreen="$screen.breakpoint === 'xs'"
      v-if="userInviteDialog"
    >
      <CloudUserInvite :project="selectedProject" v-on:invitationSent="invitationSent"></CloudUserInvite>
    </el-dialog>

    <el-dialog
      append-to-body
      :title="`Projektu dodaj uporabnika `"
      :visible.sync="userAddDialog"
      :width="userEditDialogWidth"
      :fullscreen="$screen.breakpoint === 'xs'"
      v-if="userAddDialog"
    >
      <CloudUserAdd
        :project="selectedProject"
        :ownUsers="userListBLL"
        v-on:userAdded="userAdded"
        v-on:uporabnikPovezan="userAddDialog = false"
      ></CloudUserAdd>
    </el-dialog>

    <el-dialog
      class="dangerDialog"
      append-to-body
      title="Izbris projekta"
      :visible.sync="deleteProjectDialog"
      :width="userEditDialogWidth"
      :fullscreen="$screen.breakpoint === 'xs'"
      v-if="deleteProjectDialog"
    >
      <div>Ste prepričani da želite izbrisati projekt?</div>
      <div style="margin: 10px 0px 5px 0px">Ko izbrišete projekt se zgodi sledeče: </div>
      <ul style="margin-left: 25px;">
        <li>preneha se zaračunavanje storitev povezanih s projektom,</li>
        <li>onemogočen je dostop do celotnega projekta,</li>
        <li><b>izguba vseh podatkov</b> povezanih s projektom (izbris omrežja, instanc, podatkov,...).</li>
      </ul>
      <div style="margin: 40px 0px 20px 0px">Če ste prepričani, da želite izbrisati projekt, potem vtipkajte svoje ime projekta: <br/><b>{{selectedProject.name}}</b>. </div>
      <el-form
        :model="deleteProjectForm"
        status-icon
        :rules="deleteProjectFormRules"
        ref="deleteProjectForm"
        size="mini"
        :inline-message="true"
      >
        <el-form-item prop="deleteProjectConfirmInput">
          <el-input type="text" autocomplete="off" v-model="deleteProjectForm.deleteProjectConfirmInput" placeholder="Ime projekta"></el-input>
        </el-form-item>
      </el-form>
      <template v-slot:footer>
        <el-button size="mini" @click="deleteProjectDialog = false">
          Prekliči
        </el-button>
        <el-button type="danger" size="mini" @click="deleteProjectAction" :loading="deleteInProgress">
          Odstrani projekt
        </el-button>
      </template>
    </el-dialog>

  </div>
</template>

<script>
import {Button, Col, Row, Select, Option, Card, Dialog, Divider, Tooltip, Input} from 'element-ui'
import 'element-ui/lib/theme-chalk/display.css'
import CloudUserEdit from './T2Cloud/CloudUserEdit'
import CloudUserInvite from './T2Cloud/CloudUserInvite'
import CloudUserAdd from './T2Cloud/CloudUserAdd'
import CloudProjectEdit from './T2Cloud/CloudProjectEdit'
import {CloudProjectList} from '../../../../assets/js/T2Cloud/CloudProjectList'
import {CloudUserList} from '../../../../assets/js/T2Cloud/CloudUserList'
import LoggedInUser from '../../../../assets/js/Common/LoggedInUser'
import CloudPermissionRequests from './T2Cloud/CloudPermissionRequests'

export default {
  name: 'T2Cloud',
  components: {
    CloudPermissionRequests,
    CloudProjectEdit,
    CloudUserAdd,
    CloudUserInvite,
    CloudUserEdit,
    [Button.name]: Button,
    [Row.name]: Row,
    [Col.name]: Col,
    [Select.name]: Select,
    [Option.name]: Option,
    [Card.name]: Card,
    [Dialog.name]: Dialog,
    [Divider.name]: Divider,
    [Tooltip.name]: Tooltip,
    [Input.name]: Input
  },
  data () {
    return {
      allLoaded: false,
      selectedProject: null,
      userEditDialog: false,
      userEdit: null,
      userInviteDialog: false,
      userAddDialog: false,
      editProjectPage: false,
      projectListBLL: new CloudProjectList(),
      userListBLL: new CloudUserList(),
      loggedInUser: new LoggedInUser(),
      deleteProjectDialog: false,
      deleteProjectForm: {
        deleteProjectConfirmInput: null
      },
      deleteProjectFormRules: {
        deleteProjectConfirmInput: [
          {validator: this.formValidation.inputNotEmptyValidation, trigger: 'blur'},
          {validator: this.deleteProjectMatchRule, trigger: 'blur'}
        ]
      },
      deleteInProgress: false
    }
  },
  computed: {
    userEditDialogWidth () {
      if (this.$screen.breakpoint === 'sm') {
        return '90%'
      }
      return '600px'
    },
    rowType () {
      if (!this.$screen.xl) {
        return '—'
      }
      return 'flex'
    },
    isSelectedProjectAndOwner () {
      return this.selectedProject !== null && this.selectedProject.owner && this.selectedProject.projectId !== null
    }
  },
  async created () {
    Promise.all([
      this.projectListBLL.loadProjectList(),
      this.userListBLL.loadAllUsers(),
      this.loggedInUser.loadLoggedInUserDetails()
    ]).then(() => {
      this.allLoaded = true
    }).catch((e) => {
      this.ShowErrorMessage(this.getMessageFromResponse(e))
    })
  },
  methods: {
    canAddUser (project) {
      if (project.owner) {
        return true
      }
      let userExists = false
      project.users.list.forEach((user) => {
        if (user.ownUser) {
          userExists = true
        }
      })

      return !userExists
    },
    deleteProjectMatchRule (rule, value, callback) {
      if (value !== this.selectedProject.name) {
        callback(new Error('Polje se mora ujemati z imenom projekta'))
      } else {
        callback()
      }
    },
    canInviteOthers (project) {
      return project.owner || project.maintainer
    },
    editUserClick (user) {
      this.userEdit = user
      this.userEditDialog = true
    },
    projectOwnershipColor (project) {
      if (project.owner) {
        return 'green'
      }
      if (project.maintainer) {
        return 'blue'
      }
      return 'black'
    },
    projectOwnershipDescription (project) {
      if (project.owner) {
        return 'Lastnik projekta'
      }
      if (project.maintainer) {
        return 'Skrbnik projekta'
      }
      return 'Uporabnik'
    },
    userAdded (item) {
      this.projectListBLL.addUserToProject(item.user, item.idTerminationPoint)
      this.userListBLL.addUserToList(item.user)
      this.userAddDialog = false
      this.ShowSuccessMessage({message: 'Uporabnik uspešno dodan'})
    },
    invitationSent () {
      this.userInviteDialog = false
      this.selectedProject._detailsLoaded = false
      this.getProjectDetails()
    },
    userClass (userIndex) {
      return userIndex === (this.selectedProject.users.list.length - 1) ? 'last' : ''
    },
    getProjectDetails () {
      this.selectedProject.loadProjectDetails().catch((e) => {
        this.ShowErrorMessage(this.getMessageFromResponse(e))
      })
    },
    async acceptPermissionRequest (permission) {
      await permission.acceptPermissionRequest().catch((e) => {
        this.ShowErrorMessage(this.getMessageFromResponse(e))
      })
      this.selectedProject._detailsLoaded = false
      this.getProjectDetails()
    },
    async declinePermissionRequest (permission) {
      await permission.declinePermissionRequest().catch((e) => {
        this.ShowErrorMessage(this.getMessageFromResponse(e))
      })
      this.selectedProject._detailsLoaded = false
      this.getProjectDetails()
    },
    async cancelPermissionRequest (permission) {
      await permission.cancelPermissionRequest().catch((e) => {
        this.ShowErrorMessage(this.getMessageFromResponse(e))
      })
      this.selectedProject._detailsLoaded = false
      this.getProjectDetails()
    },
    async removePermission (permission) {
      await permission.removePermission().catch((e) => {
        this.ShowErrorMessage(this.getMessageFromResponse(e))
      })
      this.selectedProject._detailsLoaded = false
      this.getProjectDetails()
    },
    async permissionRequestChanged () {
      try {
        this.selectedProject = null
        await this.projectListBLL.loadProjectList()
      } catch (e) {
        this.ShowErrorMessage(this.getMessageFromResponse(e))
      }
    },
    async deleteProjectAction () {
      this.$refs['deleteProjectForm'].validate(async (valid) => {
        if (valid) {
          try {
            this.deleteInProgress = true
            await this.selectedProject.deleteProject()
            this.ShowSuccessMessage({message: 'Projekt uspešno izbrisan'})
            this.selectedProject = null
            await this.projectListBLL.loadProjectList()
            this.deleteProjectDialog = false
          } catch (e) {
            this.ShowErrorMessage(this.getMessageFromResponse(e))
          }
          this.deleteInProgress = false
        }
      })
    },
    getMessageFromResponse (e) {
      let message = e.message
      if (e.response !== undefined && e.response.data !== undefined && e.response.data.message !== undefined) {
        message = e.response.data.message
      }
      return {message: message}
    }
  },
  watch: {
    selectedProject () {
      if (this.selectedProject !== null) {
        this.getProjectDetails()
      }
    }
  }
}
</script>

<style scoped>
.cloudUserBorderBottom:not(:last-child) {
  border-bottom: 1px dashed lightgray;
}

.projectNameBox:not(:first-child) {
  border-top: 1px dashed lightgray;
}

.projectNameSelect {
  border-radius: 0px;
  font-size: 16px;
  padding: 5px;
  border: 1px solid transparent;
  border-bottom: 1px dashed lightgray;
}

.projectNameSelect:last-child {
  border-bottom: transparent;
}

.projectNameSelect:hover:not(.selected) {
  background-color: #fafafa;
  cursor: pointer;
}

.projectNameSelect i:hover {
  cursor: pointer;
}

.projectNameSelect.selected {
  background: #FFE2C2;
}

.projectUsersListItem {
  font-size: 16px;
  padding: 0px 5px;
  border-bottom: 1px dashed lightgray;
}

.projectUsersListItem.last {
  border-bottom: transparent;
}

.projectUsersListItem:hover {
  background-color: #fafafa;
}

.projectUsersListItem i:hover {
  cursor: pointer;
}

.breadcrumbClickable {
  font-weight: bold;
}

.breadcrumbClickable:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Nastavitve/T2Cloud.vue